

import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { addFlyerStructureItem, deleteFlyerCustomElement, deleteFlyerElement, deleteFlyerStructureItem } from '../../../actions'
import { CLI_CINEMA_CLIENT_ID, CLI_MULTICINEMA_MODE, FLYER_DATA, PRINT_WEEKS, PROGRAM_ATTRIBUTES, PROGRAM_CLI_MOVIES_ITEMS, PROGRAM_CLI_MOVIES_ORDER, PROGRAM_PERFORMANCES, TRANSLATION, UI_PROGRAM } from '../../../constants/state'
import getData from '../../../functions/getData'
import toJS from '../../../hoc/toJS'
import FlyerSection from '../present/FlyerSection'
import { IMAGE, METRO, TEXT, TITLE } from '../../../constants/itemTypes'
import getOptionalCinemaId from '../../../functions/cinemaAndTimeRangeFilters/getOptionalCinemaId'
import filterMoviesByWeekAndCinema from '../../../functions/cinemaAndTimeRangeFilters/filterMoviesByWeekAndCinema'
import filterItemsByOrder from '../../../functions/cinemaAndTimeRangeFilters/filterItemsByOrder'
import filterAttributesByCinema from '../../../functions/cinemaAndTimeRangeFilters/filterAttributesByCinema'
import findWeekObWithIsoWeek from '../../../functions/findWeekObWithIsoWeek'

const mapStateToProps = state => ({
    movieOrder: getData(state, PROGRAM_CLI_MOVIES_ORDER),
    movieData: getData(state, PROGRAM_CLI_MOVIES_ITEMS),
    performancesData: getData(state, PROGRAM_PERFORMANCES),
    attributesData: getData(state, PROGRAM_ATTRIBUTES),
    flyerServerData: getData(state, FLYER_DATA),
    weeks: getData(state, PRINT_WEEKS),

    displayDropzones: getData(state, [UI_PROGRAM, 'activeDropzones']),

    currentClientCinemaId: getData(state, CLI_CINEMA_CLIENT_ID),
    multicinemaMode: getData(state, CLI_MULTICINEMA_MODE),
    translation: getData(state, TRANSLATION)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    deleteFlyerCustomContent: (type, itemId) => {
        dispatch(deleteFlyerCustomElement(itemId, type))
        
        if(type === TEXT) {
            dispatch(deleteFlyerElement('textElements', itemId))
        } else if(type === TITLE ) {
            dispatch(deleteFlyerElement('headlineElements', itemId))
        } else if(type === IMAGE) {
            dispatch(deleteFlyerElement('imageElements', itemId))
        } else if(type === METRO) {
            dispatch(deleteFlyerElement('metroElements', itemId))
        }
    },
    
    addFlyerItem: (itemId, itemType, area = false) => {
        dispatch(addFlyerStructureItem(ownProps.section, ownProps.side, area, itemId, itemType, ownProps.printPk))
    },

    deleteFlyerItem: (itemId = false, movieId = false, itemType, area = false) => {
        // console.log(ownProps.section, ownProps.side, area, itemId, movieId, itemType)
        dispatch(deleteFlyerStructureItem(ownProps.section, ownProps.side, area, itemId, movieId, itemType, ownProps.printPk))
    },
})

const getSelectedMovies = (flyerData) => {
    const selectedMovies = []
    const { moviePerformances } = flyerData

    if(!moviePerformances) { 
        return ''
    }

    moviePerformances.order.map(movPerfId => {
        selectedMovies.push(moviePerformances.items[movPerfId].movieId)
    })

    return selectedMovies
}

const FlyerSectionContainer = ({
    dragListConfig, 
    isTitlePage,

    displayDropzones,
    basicUrl,

    cinemaId,
    printType,
    printFormat,
    landscape,
    weeks,
    activeWeek, 
    section,
    side, 

    flyerServerData, 
    movieOrder,
    printPk,
    movieData,
    performancesData,
    attributesData,

    currentClientCinemaId,
    multicinemaMode,

    deleteFlyerCustomContent,
    addFlyerItem,
    deleteFlyerItem,
}) => {
    const optionalCinemaId = getOptionalCinemaId(multicinemaMode, cinemaId, currentClientCinemaId)
    let relevantMovies
    const flyerData = flyerServerData.flyers[printPk]

    if(activeWeek === "custom") {
        const {dateSettings} = flyerData
        relevantMovies = filterMoviesByWeekAndCinema(movieOrder, movieData, performancesData, null, cinemaId, dateSettings)   
    } else {
        const weekObj = findWeekObWithIsoWeek(weeks, parseInt(activeWeek))
        relevantMovies = filterMoviesByWeekAndCinema(movieOrder, movieData, performancesData, weekObj, cinemaId)
    }
    
    const selectedMovies = getSelectedMovies(flyerData)
    const relevantMoviesData = {
        order: relevantMovies.relevant,
        items: filterItemsByOrder(relevantMovies.relevant, movieData),
        selected: selectedMovies,
        current: relevantMovies.current,
        future: relevantMovies.future,
        attributes: filterAttributesByCinema(attributesData, optionalCinemaId)
    }

    return ( 
        <FlyerSection
            dragListConfig={dragListConfig}
            isTitlePage={isTitlePage}
            displayDropzones={displayDropzones}

            cinemaId={cinemaId}
            printType={printType}
            printFormat={printFormat}
            landscape={landscape}
            week={activeWeek}
            section={section}
            side={side}

            relevantMoviesData={relevantMoviesData}
            flyerData={flyerData}
            flyerServerData={flyerServerData}

            basicUrl={basicUrl}

            deleteFlyerCustomContent={deleteFlyerCustomContent}
            addFlyerItem={addFlyerItem}
            deleteFlyerItem={deleteFlyerItem}
        />
    )
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(FlyerSectionContainer)


